const layerPopup = {
  namespaced: true, // 모듈을 네임스페이스화
  state: {
    // 상태 정의
    //레이어 팝업 상태값
    showLayerPopup: false,
    //팝업모드
    popMode: null,
    //팝업메세지 초기 null setting
    popMsgState: null,
  },
  mutations: {
    // 뮤테이션 정의
    updateShowLayerPopup(state, value) {
      state.showLayerPopup = value
    },
    updatePopMode(state, popMode) {
      state.popMode = popMode;
    },
    updatePopMsgState(state, popMsgState) {
      state.popMsgState = popMsgState;
    },
  },
  actions: {
    // 액션 정의
    setPopMode({ commit }, popMode) {
      commit('updatePopMode', popMode);
    },
    setPopMsgState({ commit }, popMsgState) {
      commit('updatePopMsgState', popMsgState);
    },
  },
  getters: {
    // 게터 정의
  }
}

export default layerPopup;
